module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.choice) ? _c('p', [_vm._v("ERROR: This product option is not properly configured. Please contact us for assistance.")]) : [(_vm.choice.price_adjustment) ? _c('div', {
    staticClass: "builder__step-price-adjust"
  }, [_vm._v("\n      " + _vm._s(_vm.formattedPriceAdjustment) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "builder__step-yes-toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "builder__step-yes-toggle-input",
    attrs: {
      "type": "checkbox",
      "id": _vm.domId
    },
    domProps: {
      "value": _vm.choice.id,
      "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, _vm.choice.id) > -1 : (_vm.selected)
    },
    on: {
      "click": function($event) {
        return _vm.showEmbroideryPopup($event)
      },
      "change": function($event) {
        var $$a = _vm.selected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.choice.id,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selected = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "builder__step-yes-toggle-label",
    attrs: {
      "for": _vm.domId
    }
  }, [_c('span', {
    staticClass: "builder__step-yes-toggle-label-fake-input"
  }), _vm._v(" "), _c('span', {
    staticClass: "builder__step-yes-toggle-label-text"
  }, [_vm._v(_vm._s(_vm.choice.title))])])]), _vm._v(" "), (_vm.option.embroidery_misc_text) ? _c('div', {
    staticClass: "builder__step-note"
  }, [_vm._v("\n      " + _vm._s(_vm.option.embroidery_misc_text) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.option.embroidery_popup_text) ? _c('div', {
    staticClass: "mfp-hide builder__step-popup",
    attrs: {
      "id": _vm.popupDomId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.option.embroidery_popup_text) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.option.embroidery_example_images.length) ? _c('div', {
    staticClass: "builder__step-example-images"
  }, _vm._l((_vm.option.embroidery_example_images), function(img) {
    return _c('a', {
      staticClass: "builder__step-example-image-link",
      attrs: {
        "href": img.src
      },
      on: {
        "click": _vm.showExampleImagesPopup
      }
    }, [_vm._v("View Example")])
  }), 0) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d03c928"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/option-types/Embroidery.vue
// module id = 367
// module chunks = 0